<template>
<div>
    <div v-if="workflows && workflows.length">
        <div>
            <amf-select label='Select Workflow'
                    caption="--Select--" :columns="2"
                    :options="workflows" mapId="workflowId" mapName="description" v-model="selectedWorkflowId"></amf-select>
        </div>

        <div>
            <amf-select v-if="selectedWorkflowId" label='Select Completed Action Item to Re-Open'
                    caption="--Select--"  :columns="2"
                    :options="actionItems" v-model="selectedActionItemId"></amf-select>

            <div v-if="actionItemsToCancel && actionItemsToCancel.length" class="alert alert-warning">
                <div >Attention: this will delete subsequent action items from the workflow</div>
                <ul>
                    <li v-for="a in actionItemsToCancel" :key="a.id">
                        {{a.name}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div v-else>
        There are currently no action items to reopen.
    </div>
</div>
</template>

<script>
import { formatters } from '../framework/utils/formatters';

const status = {
    open: 1,
    approved: 2,
    completed: 4,
    cancelled: 5
}

export default {
    inject:["closeModal", "clearError"],
    props: ["employerId"],
    created() {
         this.load();
    },
    data() {
        return {
            buttons: "OK/Cancel",
            title: "Undo Workflow Step",
            selectedActionItemId: null,
            workflows: [],
            actionItemsToCancel: [],
            actionItems: [],
            selectedWorkflowId: 0,
            amfOptions: { layout: "two-column", noTracking: true },
        }
    },
    methods: {
        async load() {
            let workflows = await romeApi.get(`employer/${this.employerId}/workflow/status`);
            workflows.forEach(async w => {
                w.description = _.compact([w.type, w.status, w.orderEffectiveDate && formatters.date(w.orderEffectiveDate)]).join(", ");
                var order = await romeApi.get(`/workflow/${w.workflowId}/order`);
                if (order != null) w.description += " " + order.orderItems.join("/");
            });
            let excludedWorkflows = ['termination-workflow'];
            this.workflows = workflows.filter(wf => !excludedWorkflows.includes(wf.type));
        },
        async ok() {
            await romeApi.post(`/actionitem/v-2/${this.selectedActionItemId}/reopen`);
            this.closeModal();
        },
        validate() {
            if (this.selectedActionItemId) return;
            return "Select an action item to re-open";
        }
    },
    watch: {
        selectedWorkflowId() {
            romeApi.get(`/workflow/${this.selectedWorkflowId}/actionitems`).then(actionItems => {
                this.actionItems = actionItems
                                        .filter(a => a.statusId == status.completed || a.statusId == status.approved)
                                        .map(a => ({ id: a.actionItemId, name: a.description }));
            })
        },
        selectedActionItemId() {
            this.clearError();

            if (!this.selectedActionItemId) {
                this.actionItemsToCancel = [];
                return;
            }

            romeApi.get(`/actionitem/v-2/${this.selectedActionItemId}/successors`)
                    .then(successors => {
                        this.actionItemsToCancel = _(successors)
                                                        .filter({ statusId: status.open })
                                                        .map(ai => { return { id: ai.actionItemId, name: ai.description } })
                                                        .value();
                    })
        }
    },
    validations() {
        return {
            noop: v.build(v.noop()),
        };
    }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/workflow/UndoWorkflowModal.vue